<div class="block--content block">
    <div class="block--wrap block">
        <div class="ticket">
            <ridango-block-full-width *ngIf="success$ | async">
                <h1>{{ 'EMV_SUPPORT_SUCCESS' | translate }}</h1>

                <button class="btn btn--primary btn--square margin-bottom-30" (click)="newSearch()">
                    {{ 'BANKCARD_HISTORY_NEW_SEARCH' | translate }}
                </button>
            </ridango-block-full-width>

            <ridango-block-full-width *ngIf="(success$ | async) === false">
                <h1 class="bold margin-bottom-20 mobile-center">
                    {{ 'EMV_SUPPORT_TITLE' | translate }}
                </h1>

                <iframe
                    id="ecomm2"
                    #iframe
                    *ngIf="displayIframe"
                    [src]="tpsEndpoint | safeResourceUrl"
                    scrolling="no"
                    name="ecomm2"></iframe>

                <p *ngIf="!displayIframe">{{ 'EMV_SUCCESS_BANKCARD' | translate }}</p>

                <ng-container *ngIf="bankcardSent">
                    <h2 class="edit-profile-account-items-area__title">{{ 'EMV_YOUR_DETAILS' | translate }}</h2>

                    <form [formGroup]="customerForm" (ngSubmit)="submitDataCustomer()" ridangoFocusInvalidInput>
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="customerForm.controls.client_name"
                                ridangoInput
                                name="client_name"
                                type="text"
                                required />
                            <ridango-label>{{ 'EMV_YOUR_NAME' | translate }}</ridango-label>
                            <ridango-error *ngIf="customerForm.controls.client_name.hasError('required')">
                                {{ 'LOCAL_INPUT_VALIDATION_NAME' | translate }}
                            </ridango-error>
                        </ridango-form-field>

                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="customerForm.controls.client_phone"
                                ridangoInput
                                name="client_phone"
                                type="tel"
                                required />
                            <ridango-label>{{ 'EMV_YOUR_PHONE' | translate }}</ridango-label>
                            <ridango-error *ngIf="customerForm.controls.client_phone.hasError('required')">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE' | translate }}
                            </ridango-error>
                        </ridango-form-field>

                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="customerForm.controls.client_email"
                                (blur)="validateEmail()"
                                ridangoInput
                                name="client_email"
                                type="email"
                                required />
                            <ridango-label>{{ 'EMV_YOUR_EMAIL' | translate }}</ridango-label>
                            <ridango-error
                                *ngIf="
                                    customerForm.controls.client_email.hasError('required') ||
                                    customerForm.controls.client_email.hasError('email')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
                            </ridango-error>
                        </ridango-form-field>

                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="customerForm.controls.client_email_again"
                                ridangoInput
                                name="client_email_again"
                                type="email"
                                required />
                            <ridango-label>{{ 'EMV_YOUR_EMAIL-AGAIN' | translate }}</ridango-label>

                            <ridango-error
                                *ngIf="
                                    (customerForm.controls.client_email_again.hasError('required') ||
                                        customerForm.controls.client_email_again.hasError('email')) &&
                                    !customerForm.controls.client_email_again.hasError('valueMatch')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
                            </ridango-error>

                            <ridango-error *ngIf="customerForm.controls.client_email_again.hasError('valueMatch')">
                                {{ 'LOCAL_INPUT_VALIDATION_MATCH_EMAIL' | translate }}
                            </ridango-error>
                        </ridango-form-field>

                        <ridango-form-field class="form-margin-10">
                            <p class="margin-top-20">{{ 'EMV_YOUR_PROBLEM_DESCRIPTION' | translate }}*</p>
                            <textarea
                                [formControl]="customerForm.controls.client_problem_description"
                                ridangoInput
                                type="text"
                                name="client_description"
                                required>
                            </textarea>
                            <ridango-error
                                *ngIf="customerForm.controls.client_problem_description.hasError('required')">
                                {{ 'LOCAL_INPUT_PROBLEM_DESCRIPTION' | translate }}
                            </ridango-error>
                        </ridango-form-field>

                        <button class="btn btn--maximal btn--primary btn--big" type="submit">
                            {{ 'EMV_SEND' | translate }}
                        </button>
                    </form>
                </ng-container>
            </ridango-block-full-width>
        </div>
    </div>
</div>
